/**
 * 正品项目接口集合
 */
import request from './request'
export default {
  /**
   * 获取js-sdk签名
   */
  accountGetJsSdk: (urlParam) => {
    const url = `/zhengpin/wxsite/account/getJsSdk.do?url=${urlParam}`
    return request.get(url)
  },
  /**
   * 获取首页轮播图
   */
  sliderGetHomeSlider: (position) => {
    const url = `/zhengpin/wxsite/slider/getHomeSlider.do?position=${position}`
    return request.get(url)
  },
  /**
   * 获取品牌轮播图
   */
  sliderGetBrandSlider: (query) => {
    const url = `/zhengpin/wxsite/slider/getBrandSlider.do?${query}`
    return request.get(url)
  },
  /**
   * 获取新闻列表
   * type:[brand,platform]
   * type 为新闻分类： brand为品牌资讯，platform为平台资讯
   */
  newsQueryNews: (postData) => {
    const url = '/zhengpin/wxsite/news/queryNews.do'
    return request.post(url, postData)
  },
  /**
   * 获取新闻详情
   */
  newsGetNewsDetail: (id) => {
    const url = `/zhengpin/wxsite/news/getNewsDetail.do?id=${id}`
    return request.get(url)
  },
  /**
   * 获取品牌二级类型
   */
  brandGetCategoryList: (code) => {
    const url = `/zhengpin/wxsite/brand/getCategoryList.do?upperCode=${code}`
    return request.get(url)
  },
  /**
   * 获取品牌热门二级类型
   */
  brandGetHotCategoryList: () => {
    const url = `/zhengpin/wxsite/brand/getHotCategoryList.do`
    return request.get(url)
  },
  /**
   * 获取所有下级品牌列表
   */
  brandQueryAllBrand: () => {
    const url = '/zhengpin/wxsite/brand/queryAllBrand.do'
    return request.get(url)
  },
  /**
   * 获取下级品牌列表
   */
  brandQueryByName: (name) => {
    const url = `/zhengpin/wxsite/brand/queryByName.do?name=${name}`
    return request.get(url)
  },
  /**
  * 获取下级品牌列表
  */
  brandQueryBrandByCategoryId: (id) => {
    const url = `/zhengpin/wxsite/brand/queryBrandByCategoryId.do?categoryId=${id}`
    return request.get(url)
  },
  /**
   * 获取下级品牌列表
   */
  brandQueryBrand: (postData) => {
    const url = '/zhengpin/wxsite/brand/queryBrand.do'
    return request.post(url, postData)
  },
  /**
   * 根据id获取品牌详情
   */
  brandGetBrandDetail: (id) => {
    const url = `/zhengpin/wxsite/brand/getBrandDetail.do?id=${id}`
    return request.get(url)
  },
  /**
   * 提交评论
   */
  commentSaveComment: (postData) => {
    const url = '/zhengpin/wxsite/comment/saveComment.do'
    return request.post(url, postData)
  },
  /**
   * 获取评论
   */
  commentGetCommentList: (postData) => {
    const url = '/zhengpin/wxsite/comment/getCommentList.do'
    return request.post(url, postData)
  },
  /**
   * 首页pv uv统计
   * @param {String} dayTime 时间 格式为YYYY-MM-DD
   */
  accountPvuvCount: (dayTime) => {
    const url = `/zhengpin/wxsite/account/pvuvCount.do?dayTime=${dayTime}`
    return request.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/api/mobileServer.js